import React from 'react';
import { APIProvider, Map, type MapProps } from '@vis.gl/react-google-maps';
import { MYKONOS_MAP_RESTRICTION } from '@/constants/map';

export const GOOGLE_MAP_ID =
  import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID';
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_LIBRARIES = ['marker'];

export const MYKONOS_DEFAULT_CENTER = { lat: 37.445, lng: 25.365 };
export const MYKONOS_DEFAULT_ZOOM = 12;
export const MYKONOS_MIN_ZOOM = 10;

type Props = Omit<MapProps, 'mapId'> & { children?: React.ReactNode };

const MykonosMap = ({
  children,
  defaultCenter = MYKONOS_DEFAULT_CENTER,
  defaultZoom = MYKONOS_DEFAULT_ZOOM,
  minZoom = MYKONOS_MIN_ZOOM,
  restriction = MYKONOS_MAP_RESTRICTION,
  style,
  ...mapProps
}: Props) =>
  !GOOGLE_MAPS_API_KEY ? (
    <div
      style={{
        alignItems: 'center',
        background: '#f5f5f5',
        color: '#111',
        display: 'flex',
        fontSize: 14,
        height: '100%',
        justifyContent: 'center',
        padding: 16,
        textAlign: 'center',
        width: '100%',
      }}
    >
      Google Maps API key is missing. Set VITE_GOOGLE_MAPS_API_KEY before
      building the app.
    </div>
  ) : (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
      <Map
        mapId={GOOGLE_MAP_ID}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        minZoom={minZoom}
        gestureHandling="cooperative"
        clickableIcons={false}
        zoomControl
        streetViewControl={false}
        mapTypeControl={false}
        fullscreenControl={false}
        style={{ width: '100%', height: '100%', ...style }}
        restriction={restriction}
        {...mapProps}
      >
        {children}
      </Map>
    </APIProvider>
  );

export default MykonosMap;
